<template>
    <div class="about">
        <van-sticky>
            <van-nav-bar title="账号注销" :border="false" left-arrow @click-left="goBack">
            </van-nav-bar>
        </van-sticky>

        <div style="text-align: center;line-height: 50px">网查查注销须知</div>
        <div class="wcc-content">在您申请注销网查查账号之前，请您认证阅读、理解并同意《网查查注销须知》。</div>

        <div class="wcc-content">注销后，您将放弃以下权限（即使你使用相同的微信号再次登录并使用网查查）：</div>
        <div class="wcc-content">1、注销网查查微信登录账号为不可恢复的操作。</div>
        <div class="wcc-content">2、您登录的微信信息、绑定手机号信息、获得相关权益等将被清空且无法恢复。</div>
        <div class="wcc-content">3、您的测速记录、评测记录、以及其他参与记录将无法找回。</div>

        <div v-if="$cookie.get('session')"
             style="text-align: center!important;margin: 30px auto">
            <!--          已登录才显示-->

            <van-checkbox v-model="checked"
                          shape="square" icon-size="1.2em"
                          style="margin: 25px">已阅读并同意《网查查注销须知》
            </van-checkbox>

            <van-button type="info" size="small" :disabled="!checked" @click="signout">立即注销</van-button>

        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                viewType: 'list1',
                activeName: "0",
                checked: false

            }
        },
        methods: {
            goBack: function () {
                if (window.JSInterface) {
                    window.JSInterface.callMethod('close', null)
                }
                else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
                    window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
                }
            },
            signout: function () {
                this.axios.post("/openApi/signout");
                if (window.JSInterface) {
                    window.JSInterface.callMethod('reset', null)
                }
                else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
                    window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"reset\"}");
                }
            }
        }
    }
</script>

<style>
    .wcc-table td {
        border-top: 1px solid #353f53;
        border-left: 1px solid #353f53;
        padding: 3px;
    }

    .wcc-table {
        margin: 0 auto;
        border-bottom: 1px solid #353f53;
        border-right: 1px solid #353f53;
    }

    .wcc-tb-header {
        text-align: center;
        background-color: #1c3146;
    }

    .van-collapse-item__content {
        background-color: inherit !important;
    }

    .van-checkbox__label {
        color: inherit;
    }

    .wcc-header-1 {
        text-align: center;
        font-size: 1.2em;
        line-height: 2em;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .wcc-header-2 {
        font-size: 1.1em;
        line-height: 2em;
        font-weight: bold;
    }

    .wcc-content {
        text-indent: 2em;
        margin-bottom: 10px;
    }
</style>
